module.exports = __webpack_public_path__ + "images/bannerFR-0113d3c1cb3617982e8ea7d4af07bb07.png";